export default {
  path: 'provider',
  component: () =>
    import('@/views/provider/location-service-management/Wrapper.vue'),
  children: [
    {
      path: '/provider/location-service-search',
      name: 'locationServiceSearch',
      component: () =>
        import('@/views/provider/location-service-management/Main.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.providers.view.serviceplaces'],
        },
      },
    },
    {
      path:
        '/provider/location-service-management/:companyId/:locationFiscalYearId?',
      name: 'locationServiceManagement',
      component: () =>
        import(
          '@/views/provider/location-service-management/LocationServiceManagement.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.providers.view.serviceplaces'],
        },
      },
    },
  ],
};
